<template>
    <section class="col s12">
        <div class="row">
            <div class="col s12">
                <p>Sua ação responde a alguma política de ação afirmativa voltada para grupos de indivíduos constituídos por pessoas:</p> 
				<ul>
					<li>- pretas e pardas;</li>
					<li>- indígenas;</li>
					<li>- quilombolas;</li>
					<li>- com deficiência;</li>
					<li>- com transtorno global do desenvolvimento;</li>
					<li>- transsexuais/transgêneros, travestis e não binários, ou</li>
					<li>- estudantes em atividade parental, identidades femininas e cuidadoras de idosos.</li>
				</ul>
				
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_afirmativa"
                               class="with-gap"
                               type="radio"
                               id="rdSimAcaoAfirmativa"
                               :disabled="allDisabled"
                               :value="true"
                               v-model="acaoAfirmativa" />
                        <span>Sim</span>
                    </label>
                </div>
                <div class="col custom-col">
                    <label>
                        <input tipo="materialize"  name="acao_afirmativa"

                               class="with-gap"
                               type="radio"
                               id="rdNaoAcaoAfirmativa"
                               :disabled="allDisabled"
                               :value="false"
                               v-model="acaoAfirmativa" />
                        <span>Não</span>
                    </label>
                </div>
            </div>
        </div>

        <div class="row" v-if="acaoAfirmativa">
            <section class="animate__animated animate__fadeInDown">
                <div class="col s12">
                    <p><b>Qual política e como?</b></p>
                </div>

                <div class="col s12">
					<textarea style="width: 100%; min-height: 150px;" name="descAcaoAfirmativa"
								  id="descAcaoAfirmativa"
								  maxlength="2000"
								  :disabled="allDisabled"
								  v-model="descAcaoAfirmativa"
								  cols="30" rows="10"
								  class="browser-default">
					</textarea>            
					<span class="right" style="font-size: small;">{{ !descAcaoAfirmativa ? 0 : descAcaoAfirmativa.length }} / 2000</span>
				</div>
            </section>
        </div>

        <Resultado_avaliacoes_itens_acao v-if="avaliacoes"
                                         :avaliacoes="avaliacoes"
                                         campo-referente-na-inscricao="acao_afirmativa"></Resultado_avaliacoes_itens_acao>
    </section>
</template>

<script>
import 'animate.css';
import Resultado_avaliacoes_itens_acao from "./avaliacoes_resultado/resultado_avaliacoes_itens_acao";

export default {
    name: "inscricao_acoes_afirmativas",
    components: {Resultado_avaliacoes_itens_acao},
    props: {
        pAcaoAfirmativa: {
            type: Boolean,
            default: false,
        },
        pDescAcaoAfirmativa: {
            type: String,
            default: null,
        },
        allDisabled: {
            type: Boolean,
            default: false,
        },
        pAvaliacoes: {
            type: Array|null,
            default: null,
        }
    },
    data() {
        return {
            acaoAfirmativa: this.pAcaoAfirmativa,
            descAcaoAfirmativa: this.pDescAcaoAfirmativa,
            avaliacoes: this.pAvaliacoes,
        }
    },
    watch: {
        pAcaoAfirmativa(newValue) {
            this.acaoAfirmativa = newValue
        },
        acaoAfirmativa(newValue) {
            
            this.$emit('update:pAcaoAfirmativa', newValue)
        },
        pDescAcaoAfirmativa: {
            deep: true,
            handler(newValue){
                this.descAcaoAfirmativa = newValue
            }
        },
        descAcaoAfirmativa: {
            deep: true,
            handler(newValue){
                this.$emit('update:pDescAcaoAfirmativa', newValue)
            }
        },
    },
}
</script>
